(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blumquiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var TRAITS = ['chaos', 'meme', 'motor', 'outdoors', 'adventure', 'tradie', 'clean'];
  var LABELS = { chaos: 'Chaos', meme: 'Meme energy', motor: 'Car culture', outdoors: 'Mud / off-road', adventure: 'Adventure outdoors', tradie: 'Tradie', clean: 'Clean' };

  var questions = [
    { q: 'Your car / van / toolbox needs one thing. What is it?', answers: [
      ['Something wildly inappropriate', {chaos:4,meme:3}], ['A joke only the internet understands', {meme:5,chaos:1}], ['A proper motorsport touch', {motor:5,clean:2}], ['Something that says I actually go outside', {adventure:5,outdoors:2,clean:1}]
    ]},
    { q: 'Pick your natural habitat.', answers: [
      ['A car meet at an unreasonable hour', {motor:5,chaos:1}], ['A muddy lane where the sat nav gives up', {outdoors:6,chaos:1}], ['The workshop, obviously', {tradie:5,motor:2}], ['A campsite, trail or mountain with barely any signal', {adventure:6}]
    ]},
    { q: 'How much trouble should your sticker cause?', answers: [
      ['None. Keep it tidy.', {clean:5,motor:1}], ['A smirk is enough.', {meme:3,clean:2}], ['I want people taking photos.', {meme:3,chaos:3}], ['Potentially an HR meeting.', {chaos:6,tradie:1}]
    ]},
    { q: 'Someone says “nice sticker”. Your ideal response?', answers: [
      ['Cheers mate.', {tradie:4,clean:2}], ['You should see the rest of the car.', {motor:5}], ['I picked it up after another questionable outdoor purchase.', {adventure:5,outdoors:2}], ['No explanation. Just eye contact.', {chaos:5,meme:1}]
    ]},
    { q: 'Choose your weekend.', answers: [
      ['Cleaning the car properly', {clean:5,motor:3}], ['Green lanes, 4x4s and getting absolutely covered in mud', {outdoors:6}], ['Hiking, camping, climbing or disappearing into the outdoors', {adventure:6}], ['Fixing something that was “fine yesterday”', {tradie:5,motor:2}]
    ]},
    { q: 'Where is this sticker most likely ending up?', answers: [
      ['Rear window / bodywork', {motor:5,clean:1}], ['Toolbox / work van', {tradie:6}], ['4x4 / off-road rig / muddy bit of kit', {outdoors:6}], ['Bottle / camper / roof box / adventure gear', {adventure:6}]
    ]},
    { q: 'Final one. Pick the rule you live by.', answers: [
      ['Less is more.', {clean:6}], ['Built, not bought.', {motor:5,tradie:2}], ['Take the scenic route.', {adventure:6}], ['If in doubt, send it.', {outdoors:4,chaos:4,meme:1}]
    ]}
  ];

  function each(list, fn) {
    for (var i = 0; i < list.length; i += 1) fn(list[i], i);
  }

  function freshScores() {
    var out = {};
    each(TRAITS, function (trait) { out[trait] = 0; });
    return out;
  }

  function scrollToQuizTop(root, configData) {
    if (!root) return;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1024;
    var desktopOffset = configData && configData.scrollOffsetDesktop ? Number(configData.scrollOffsetDesktop) : 0;
    var mobileOffset = configData && configData.scrollOffsetMobile ? Number(configData.scrollOffsetMobile) : 0;
    var offset = viewportWidth <= 800 ? mobileOffset : desktopOffset;
    var quizTop = root.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
    window.scrollTo(0, Math.max(0, quizTop - offset));
  }

  function shuffle(items) {
    for (var i = items.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = items[i];
      items[i] = items[j];
      items[j] = temp;
    }
    return items;
  }

  function weightedBestSellerShuffle(items, biasPercent) {
    var pool = items.slice(0);
    var output = [];
    var bias = Math.max(0, Math.min(100, Number(biasPercent) || 0));

    if (bias <= 0) return shuffle(pool);

    while (pool.length) {
      var totalWeight = 0;
      var weights = [];
      var length = pool.length;

      for (var i = 0; i < length; i += 1) {
        var rankScore = (length - i) / length;
        var weight = 1 + (bias / 10) * rankScore * rankScore;
        weights.push(weight);
        totalWeight += weight;
      }

      var target = Math.random() * totalWeight;
      var running = 0;
      var chosenIndex = 0;

      for (var j = 0; j < weights.length; j += 1) {
        running += weights[j];
        if (target <= running) {
          chosenIndex = j;
          break;
        }
      }

      output.push(pool.splice(chosenIndex, 1)[0]);
    }

    return output;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'\"]/g, function (c) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','\"':'&quot;'}[c];
    });
  }

  function parseJson(root, selector) {
    var node = root.querySelector(selector);
    if (!node) return null;
    try { return JSON.parse(node.textContent || node.innerText || '{}'); }
    catch (err) {
      if (window.console && console.error) console.error('Blum Quiz JSON error', err);
      return null;
    }
  }


  function loadShareImage(url, callback) {
    if (!url) { callback(null); return; }
    var image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = function () { callback(image); };
    image.onerror = function () { callback(null); };
    image.src = url;
  }

  function drawCoverImage(ctx, image, x, y, width, height) {
    if (!image || !image.width || !image.height) return;
    var scale = Math.max(width / image.width, height / image.height);
    var drawWidth = image.width * scale;
    var drawHeight = image.height * scale;
    var drawX = x + (width - drawWidth) / 2;
    var drawY = y + (height - drawHeight) / 2;
    ctx.drawImage(image, drawX, drawY, drawWidth, drawHeight);
  }

  function drawContainedImage(ctx, image, x, y, width, height) {
    if (!image || !image.width || !image.height) return;
    var scale = Math.min(width / image.width, height / image.height);
    var drawWidth = image.width * scale;
    var drawHeight = image.height * scale;
    var drawX = x + (width - drawWidth) / 2;
    var drawY = y + (height - drawHeight) / 2;
    ctx.drawImage(image, drawX, drawY, drawWidth, drawHeight);
  }

  function wrapCanvasText(ctx, text, maxWidth) {
    var words = String(text || '').split(/\s+/);
    var lines = [];
    var line = '';
    for (var i = 0; i < words.length; i += 1) {
      var test = line ? line + ' ' + words[i] : words[i];
      if (line && ctx.measureText(test).width > maxWidth) {
        lines.push(line);
        line = words[i];
      } else {
        line = test;
      }
    }
    if (line) lines.push(line);
    return lines;
  }

  function drawRoundedRect(ctx, x, y, width, height, radius) {
    var r = Math.min(radius, width / 2, height / 2);
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + width - r, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + r);
    ctx.lineTo(x + width, y + height - r);
    ctx.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
    ctx.lineTo(x + r, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
  }

  function generateShareCanvas(shareData, configData, callback) {
    var canvas = document.createElement('canvas');
    var exportScale = 2;
    canvas.width = 2160;
    canvas.height = 2700;
    var ctx = canvas.getContext('2d');
    if (!ctx) { callback(null); return; }
    ctx.scale(exportScale, exportScale);

    var bg = configData.shareBackground || '#111111';
    var fg = configData.shareForeground || '#ffffff';
    var accent = configData.shareAccent || '#ffffff';
    var logoUrl = configData.shareLogo || '';
    var products = shareData.products.slice(0, 5);
    var bottomLogoUrl = configData.shareBottomLogo || '';
    var backgroundImageUrl = configData.shareBackgroundImage || '';
    var urls = [logoUrl, bottomLogoUrl, backgroundImageUrl];
    each(products, function (p) { urls.push(p.image || ''); });

    var images = [];
    var remaining = urls.length;

    function finishLoad() {
      remaining -= 1;
      if (remaining > 0) return;

      ctx.fillStyle = bg;
      ctx.fillRect(0, 0, 1080, 1350);

      var backgroundImage = images[2];
      if (backgroundImage) {
        drawCoverImage(ctx, backgroundImage, 0, 0, 1080, 1350);
      }

      // Subtle branded background treatment.
      ctx.globalAlpha = 0.07;
      ctx.strokeStyle = accent;
      ctx.lineWidth = 3;
      for (var gx = -200; gx < 1300; gx += 105) {
        ctx.beginPath();
        ctx.moveTo(gx, 0);
        ctx.lineTo(gx + 650, 1350);
        ctx.stroke();
      }
      ctx.globalAlpha = 1;

      var logo = images[0];
      var bottomLogo = images[1];
      var logoAreaHeight = Number(configData.shareLogoAreaHeight || 230);
      var logoTop = 58;

      if (logo) {
        drawContainedImage(ctx, logo, 90, logoTop, Number(configData.shareTopLogoWidth || 340), Number(configData.shareTopLogoHeight || 130));
      } else {
        ctx.fillStyle = fg;
        ctx.font = '900 48px ' + (configData.shareHeadingFont || 'Arial') + ', sans-serif';
        ctx.fillText('BLUM', 90, 135);
      }

      if (bottomLogo) {
        var secondaryLogoWidth = Number(configData.shareBottomLogoWidth || 390);
        var secondaryLogoHeight = Number(configData.shareBottomLogoHeight || 125);
        var secondaryScale = Math.min(secondaryLogoWidth / bottomLogo.width, secondaryLogoHeight / bottomLogo.height);
        var secondaryDrawWidth = bottomLogo.width * secondaryScale;
        var secondaryDrawHeight = bottomLogo.height * secondaryScale;
        var secondaryDrawX = 990 - secondaryDrawWidth;
        var secondaryDrawY = logoTop + (secondaryLogoHeight - secondaryDrawHeight) / 2;
        ctx.drawImage(bottomLogo, secondaryDrawX, secondaryDrawY, secondaryDrawWidth, secondaryDrawHeight);
      }

      var eyebrowY = Math.max(245, logoTop + logoAreaHeight);
      ctx.fillStyle = accent;
      ctx.font = '900 27px ' + (configData.shareLabelFont || configData.shareHeadingFont || 'Arial') + ', sans-serif';
      ctx.letterSpacing = '1px';
      ctx.fillText(String(configData.shareEyebrow || 'YOUR STICKER PERSONALITY IS').toUpperCase(), 90, eyebrowY);

      ctx.fillStyle = fg;
      ctx.font = '900 82px ' + (configData.shareHeadingFont || 'Arial') + ', sans-serif';
      var titleLines = wrapCanvasText(ctx, String(shareData.name || '').toUpperCase(), 900);
      var titleY = eyebrowY + 95;
      each(titleLines.slice(0, 2), function (line) {
        ctx.fillText(line, 90, titleY);
        titleY += 88;
      });

      ctx.fillStyle = accent;
      ctx.fillRect(90, titleY + 4, 160, 10);

      ctx.fillStyle = fg;
      ctx.font = '500 31px ' + (configData.shareBodyFont || 'Arial') + ', sans-serif';
      var descLines = wrapCanvasText(ctx, shareData.description || '', 900);
      var descY = titleY + 70;
      each(descLines.slice(0, 4), function (line) {
        ctx.fillText(line, 90, descY);
        descY += 43;
      });

      var stripY = Math.max(670, descY + 50);
      ctx.fillStyle = accent;
      drawRoundedRect(ctx, 90, stripY, 900, 66, 33);
      ctx.fill();
      ctx.fillStyle = bg;
      ctx.font = '900 28px ' + (configData.shareLabelFont || configData.shareHeadingFont || 'Arial') + ', sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText(String(configData.shareStickerHeading || 'MY TOP 5 STICKER PICKS').toUpperCase(), 540, stripY + 44);
      ctx.textAlign = 'left';

      var cardY = stripY + 100;
      var cardW = Number(configData.shareStickerSize || 170);
      var cardH = cardW;
      var gap = 12;
      var totalCardsWidth = (cardW * 5) + (gap * 4);
      var cardsStartX = (1080 - totalCardsWidth) / 2;
      for (var i = 0; i < 5; i += 1) {
        var x = cardsStartX + i * (cardW + gap);
        ctx.save();
        ctx.fillStyle = 'rgba(255,255,255,0.06)';
        drawRoundedRect(ctx, x, cardY, cardW, cardH, Number(configData.shareStickerRadius || 28));
        ctx.fill();
        ctx.strokeStyle = accent;
        ctx.lineWidth = 2;
        ctx.stroke();

        if (images[i + 3]) {
          drawContainedImage(ctx, images[i + 3], x + 8, cardY + 8, cardW - 16, cardH - 16);
        }
        ctx.restore();
      }

      ctx.textAlign = 'left';
      ctx.fillStyle = fg;
      ctx.font = '700 ' + Number(configData.shareFooterFontSize || 25) + 'px ' + (configData.shareBodyFont || 'Arial') + ', sans-serif';
      ctx.fillText(configData.shareFooter || 'blumdecals.com', 90, 1260);
      ctx.textAlign = 'left';

      callback(canvas);
    }

    if (!remaining) {
      callback(canvas);
      return;
    }

    each(urls, function (url, index) {
      loadShareImage(url, function (image) {
        images[index] = image;
        finishLoad();
      });
    });
  }

  function shareResultImage(shareData, configData, button, message) {
    if (!shareData || !shareData.products || !shareData.products.length) return;
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Creating your image…';
    if (message) message.setAttribute('hidden', 'hidden');

    generateShareCanvas(shareData, configData, function (canvas) {
      if (!canvas) {
        button.disabled = false;
        button.textContent = originalText;
        if (message) {
          message.textContent = 'Sorry — the share image could not be created.';
          message.removeAttribute('hidden');
        }
        return;
      }

      canvas.toBlob(function (blob) {
        button.disabled = false;
        button.textContent = originalText;

        if (!blob) {
          if (message) {
            message.textContent = 'Sorry — the share image could not be created.';
            message.removeAttribute('hidden');
          }
          return;
        }

        var safeName = String(shareData.name || 'sticker-result').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        var filename = 'blum-' + (safeName || 'sticker-result') + '.png';
        var file = null;

        try {
          file = new File([blob], filename, { type: 'image/png' });
        } catch (err) {
          file = null;
        }

        var isMobileShareDevice = false;
        var coarsePointer = false;
        var smallViewport = false;

        try {
          coarsePointer = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
        } catch (err2) {}

        smallViewport = (window.innerWidth || document.documentElement.clientWidth || 1024) <= 820;
        isMobileShareDevice = coarsePointer || smallViewport;

        if (isMobileShareDevice && file && navigator.share && navigator.canShare) {
          try {
            if (navigator.canShare({ files: [file] })) {
              navigator.share({
                files: [file],
                title: 'My Blum sticker personality: ' + (shareData.name || ''),
                text: 'I took the Blum sticker personality quiz.'
              }).catch(function () {});
              return;
            }
          } catch (err3) {}
        }

        var url = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.setTimeout(function () { URL.revokeObjectURL(url); }, 2000);

        if (message) {
          message.textContent = 'Image saved — open Instagram and add it to your post or story.';
          message.removeAttribute('hidden');
        }
      }, 'image/png', 1);
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-initialized') === 'true') return;
    root.setAttribute('data-initialized', 'true');

    var resultData = parseJson(root, '[data-blum-results]');
    var configData = parseJson(root, '[data-blum-config]');
    if (!resultData || !configData) {
      root.setAttribute('data-initialized', 'error');
      return;
    }

    var stageNodes = root.querySelectorAll('[data-stage]');
    var stages = {};
    each(stageNodes, function (el) { stages[el.getAttribute('data-stage')] = el; });

    var qMount = root.querySelector('[data-question]');
    var progress = root.querySelector('[data-progress]');
    var progressLabel = root.querySelector('[data-progress-label]');
    var index = 0;
    var scores = freshScores();
    var currentShareData = null;

    function show(name) {
      each(stageNodes, function (stage) {
        if (stage.getAttribute('data-stage') === name) stage.removeAttribute('hidden');
        else stage.setAttribute('hidden', 'hidden');
      });
    }

    function restart(event) {
      if (event) { event.preventDefault(); event.stopPropagation(); }
      index = 0;
      scores = freshScores();
      currentShareData = null;
      show('intro');

      scrollToQuizTop(root, configData);
    }

    function begin(event) {
      if (event) { event.preventDefault(); event.stopPropagation(); }
      try {
        index = 0;
        scores = freshScores();
        show('quiz');
        renderQuestion();
        scrollToQuizTop(root, configData);
    } catch (err) {
        if (window.console && console.error) console.error('Blum Quiz start error', err);
        show('intro');
      }
    }

    function renderQuestion() {
      var item = questions[index];
      if (!item || !qMount) return;

      progress.style.width = ((index / questions.length) * 100) + '%';
      progressLabel.textContent = 'Question ' + (index + 1) + ' of ' + questions.length;
      while (qMount.firstChild) qMount.removeChild(qMount.firstChild);

      var kicker = document.createElement('p');
      kicker.className = 'blum-quiz__question-kicker';
      kicker.textContent = index === questions.length - 1 ? 'Nearly there' : 'Highly scientific question';

      var title = document.createElement('h3');
      title.className = 'blum-quiz__question';
      title.textContent = item.q;

      var answers = document.createElement('div');
      answers.className = 'blum-quiz__answers';

      each(item.answers, function (answer) {
        var label = answer[0];
        var points = answer[1];
        var button = document.createElement('button');
        button.setAttribute('type', 'button');
        button.className = 'blum-quiz__answer';
        button.textContent = label;
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          for (var trait in points) {
            if (Object.prototype.hasOwnProperty.call(points, trait)) scores[trait] += points[trait];
          }
          index += 1;
          if (index >= questions.length) renderResult();
          else renderQuestion();
        }, false);
        answers.appendChild(button);
      });

      qMount.appendChild(kicker);
      qMount.appendChild(title);
      qMount.appendChild(answers);
    }

    function renderResult() {
      var ranked = [];
      for (var trait in scores) {
        if (Object.prototype.hasOwnProperty.call(scores, trait)) ranked.push([trait, scores[trait]]);
      }
      ranked.sort(function (a, b) { return b[1] - a[1]; });

      var winner = ranked[0][0];
      var data = resultData[winner];
      if (!data) return;
      show('result');

      root.querySelector('[data-result-kicker]').textContent = data.kicker || 'Your sticker personality is';
      root.querySelector('[data-result-name]').textContent = data.name || '';
      root.querySelector('[data-result-description]').textContent = data.description || '';

      each(root.querySelectorAll('[data-collection-link]'), function (a) {
        a.setAttribute('href', data.collectionUrl || '/collections/all');
      });

      var max = 1;
      each(ranked, function (row) { if (row[1] > max) max = row[1]; });
      var dna = root.querySelector('[data-dna]');
      while (dna.firstChild) dna.removeChild(dna.firstChild);
      each(ranked.slice(0, 3), function (row) {
        var pill = document.createElement('span');
        pill.className = 'blum-quiz__dna-pill';
        pill.textContent = LABELS[row[0]] + ' ' + Math.round((row[1] / max) * 100) + '%';
        dna.appendChild(pill);
      });

      var bundleMount = root.querySelector('[data-bundles]');
      var empty = root.querySelector('[data-empty]');
      var cartMessage = root.querySelector('[data-cart-message]');
      while (bundleMount.firstChild) bundleMount.removeChild(bundleMount.firstChild);
      cartMessage.setAttribute('hidden', 'hidden');

      var priorityProducts = [];
      var collectionProducts = [];
      var seenVariants = {};
      each(data.products || [], function (product) {
        if (!product || !product.variantId) return;
        var key = String(product.variantId);
        if (seenVariants[key]) return;
        seenVariants[key] = true;
        if (product.priority) priorityProducts.push(product);
        else collectionProducts.push(product);
      });
      collectionProducts = weightedBestSellerShuffle(collectionProducts, configData.bestSellerBias);
      var products = priorityProducts.concat(collectionProducts);
      currentShareData = {
        name: data.name || '',
        description: data.description || '',
        products: products.slice(0, 5)
      };
      var tiers = configData.tiers || [];

      if (products.length < 4) {
        empty.removeAttribute('hidden');
        bundleMount.setAttribute('hidden', 'hidden');
      } else {
        empty.setAttribute('hidden', 'hidden');
        bundleMount.removeAttribute('hidden');
      }

      each(tiers, function (tier) {
        var chosen = products.slice(0, tier.count);
        bundleMount.appendChild(renderBundle(tier, chosen, data.name || 'sticker', cartMessage));
      });

      progress.style.width = '100%';
    }

    function renderBundle(tier, products, personalityName, cartMessage) {
      var complete = products.length === tier.count;
      var card = document.createElement('article');
      card.className = 'blum-quiz__bundle' + (tier.featured ? ' blum-quiz__bundle--featured' : '');

      var thumbs = '';
      each(products, function (p, i) {
        thumbs += '<a class="blum-quiz__bundle-thumb" href="' + escapeHtml(p.url) + '" aria-label="' + escapeHtml(p.title) + '">' +
          (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" loading="lazy" width="180" height="180">' : '') +
          '<span>' + Math.max(97 - (i * 2), 78) + '%</span></a>';
      });

      card.innerHTML =
        (tier.featured ? '<span class="blum-quiz__bundle-badge">Most popular</span>' : '') +
        '<h4 class="blum-quiz__bundle-size">' + escapeHtml(tier.title) + '</h4>' +
        '<p class="blum-quiz__bundle-price">' + escapeHtml(tier.price) + '</p>' +
        '<p class="blum-quiz__bundle-note">' + escapeHtml(tier.note) + '</p>' +
        '<div class="blum-quiz__bundle-products">' + thumbs + '</div>' +
        '<button type="button" class="blum-quiz__button" data-add-bundle ' + (complete ? '' : 'disabled') + '>' +
        (complete ? 'Add ' + tier.count + ' for ' + escapeHtml(tier.price) : 'Assign ' + tier.count + ' stickers') + '</button>';

      var button = card.querySelector('[data-add-bundle]');
      if (complete) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          addBundle(button, tier, products, personalityName, cartMessage);
        }, false);
      }
      return card;
    }

    function addBundle(button, tier, products, personalityName, cartMessage) {
      var original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding your picks…';
      cartMessage.setAttribute('hidden', 'hidden');

      var routeRoot = '/';
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) routeRoot = window.Shopify.routes.root;

      var items = [];
      each(products, function (product) { items.push({ id: parseInt(product.variantId, 10), quantity: 1 }); });

      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () { return {}; }).then(function (error) {
            throw new Error(error.description || error.message || 'Shopify could not add this bundle.');
          });
        }
        return response.json();
      }).then(function () {
        var trackingAttributes = {
          'Sticker Picker': 'Yes',
          'Sticker Picker Result': personalityName || '',
          'Sticker Picker Bundle': tier.count + ' stickers'
        };

        return fetch(routeRoot + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: trackingAttributes })
        }).catch(function () {
          return null;
        });
      }).then(function () {
        cartMessage.textContent = tier.count + ' ' + personalityName + ' picks added. Taking you to your cart…';
        cartMessage.removeAttribute('hidden');
        window.location.href = routeRoot + 'cart';
      }).catch(function (error) {
        cartMessage.textContent = error.message || 'Something went wrong adding the bundle. Please try again.';
        cartMessage.removeAttribute('hidden');
        button.disabled = false;
        button.textContent = original;
      });
    }

    var startButton = root.querySelector('[data-start]');
    if (startButton) startButton.addEventListener('click', begin, false);
    var shareButton = root.querySelector('[data-share-result]');
    var shareMessage = root.querySelector('[data-share-message]');
    if (shareButton) {
      shareButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        shareResultImage(currentShareData, configData, shareButton, shareMessage);
      }, false);
    }

    each(root.querySelectorAll('[data-restart]'), function (button) {
      button.addEventListener('click', restart, false);
    });
  }

  function initAll(scope) {
    var area = scope || document;
    each(area.querySelectorAll('[data-blum-quiz]'), init);
  }

  function boot() { initAll(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, false);
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelectorAll) initAll(event.target);
  }, false);
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
